import Special3DConcretePrinting_EN from '../assets/videos/Special3DConcretePrinting/EN.mp4';
import Special3DConcretePrinting_DE from '../assets/videos/Special3DConcretePrinting/DE.mp4';

import SustainabilityCommitments2030_EN from '../assets/videos/SustainabilityCommitments2030/EN.mp4';
import SustainabilityCommitments2030_DE from '../assets/videos/SustainabilityCommitments2030/DE.mp4';


export const videos_EN = {
  Special3DConcretePrinting_EN,
  SustainabilityCommitments2030_EN
}

export const videos_DE = {
  Special3DConcretePrinting_DE,
  SustainabilityCommitments2030_DE
}


export const videos = {
  ...videos_EN,
  ...videos_DE
}